import { render, staticRenderFns } from "./EdpassPrint.vue?vue&type=template&id=1ec696fc&scoped=true&"
import script from "./EdpassPrint.vue?vue&type=script&lang=js&"
export * from "./EdpassPrint.vue?vue&type=script&lang=js&"
import style0 from "./EdpassPrint.vue?vue&type=style&index=0&id=1ec696fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec696fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/User/Documents/subhash/schoolportal/customerportal/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
installComponents(component, {VApp})
